import { useContext, useCallback } from 'react'

import { AuthContext } from './AuthContext'

export function useAuth() {
  const {
    authEvent,
    updateAuth,
    refreshToken,
    authInitialized,
    AmplifyCore,
    AmplifyAuth,
    signOut,
    currentSession,
    getAccessToken,
    claims,
    language,
    setAuthEvent,
  } = useContext(AuthContext)

  const getPartnerId = useCallback(() => {
    return claims?.partnerId
  }, [claims])

  const getRoles = useCallback(() => {
    return claims?.accountType ? [claims?.accountType] : []
  }, [claims])

  const hasOneOfRoles = useCallback(
    (roles = []) => {
      if (!roles.length) {
        return true
      }

      return roles.includes(claims?.accountType)
    },
    [claims]
  )

  return {
    authEvent,
    updateAuth,
    refreshToken,
    authInitialized,
    AmplifyCore,
    AmplifyAuth,
    signOut,
    currentSession,
    claims,
    language,
    getAccessToken,
    getPartnerId,
    getRoles,
    hasOneOfRoles,
    setAuthEvent,
    userEnabled: claims?.enabled,
  }
}
